// extracted by mini-css-extract-plugin
export default {"cell":"Cell_cell__ZdM9-","label":"Cell_label__2UsmU"};